<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="title"></drdp-title>
    <div>
      <p>
        {{ t('progressReports.description') }}
      </p>
    </div>
  </div>
  <drdp-report-search [multiSelectClassrooms]="false"
    [multiSelectSites]="false"
    [showLocale]="true"
    [is2025]="is2025"
    [showStudentSelect]="true"
    [onlyLocked]="true"
    [canSelectAll]="true"
    [requiredFields]="requiredFields"
    [displayActivitiesBankBtn]="is2025" 
    (showReportClicked)="showReport($event)"
    (downloadReportClicked)="downloadReport($event)"
    (activitiesBankReportClicked)="handleActivitiesBankReport($event)"
    (clearClicked)="handleClear()"></drdp-report-search>
  @if (!!reportData) {
    <div [innerHtml]="reportData! | safeHtml"></div>
  }
  <drdp-activity-bank-results [reportData]="activityBankReportData" [isParentProgressActivities]="true"></drdp-activity-bank-results>
</div>
</ng-container>
